.circle {
	display: flex;
	align-items: center;
	justify-content: center;
	width: var(--lp-size-16);
	height: var(--lp-size-16);
	border-radius: 100%;
	border: var(--lp-border-width-200) solid var(--lp-color-border-field-base);
	background: var(--lp-color-bg-field-base);
	transition:
		all var(--lp-duration-100) ease-in-out,
		outline,
		outline-offset 0ms;

	& .icon {
		fill: var(--lp-color-fill-interactive-primary);
		width: var(--lp-size-16);
		height: var(--lp-size-16);
	}
}

.radio {
	composes: interactive from './base.module.css';
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: var(--lp-size-8);
	font: var(--lp-text-label-1-regular);
	position: relative;

	&[data-focus-visible] {
		& .circle {
			outline: 1px solid var(--lp-color-shadow-interactive-focus);
			outline-offset: -1px;
			z-index: 1;
		}
	}

	&[data-selected] {
		& .circle {
			background-color: var(--lp-color-bg-interactive-primary-base);
			border-color: var(--lp-color-border-interactive-primary-base);
		}
	}

	&[data-disabled] {
		color: var(--lp-color-text-field-disabled);

		& .circle {
			background-color: var(--lp-color-bg-field-disabled);
			border-color: var(--lp-color-bg-field-disabled);

			& .icon {
				fill: var(--lp-color-fill-ui-primary);
				opacity: 0.6;
			}
		}
	}

	&[data-invalid] {
		& .circle {
			border-color: var(--lp-color-border-field-error);
		}
	}

	&[data-focus-visible]:is([data-selected]) {
		& .circle {
			box-shadow: inset 0 0 0 1px var(--lp-color-shadow-interactive-primary);
		}
	}
}
